import { Asset } from "rujira.js";
import { isDirectRujiraDepositAsset } from "./depositAssets";

export const EXTERNAL_TRANSFER_SOURCE = "external";

/** Assets transferred directly between Rujira addresses in the Send flow. */
export const isThorchainFundingAsset = (asset: Asset): boolean =>
  isDirectRujiraDepositAsset(asset);
